export default __webpack_public_path__ + "static/media/ranjana_srivastava.186f2c31.jpg";